function dm_posts(){
    const sections = document.querySelectorAll('.posts-page section.filter');
    if (!sections.length) return;

    sections.forEach((section) => {
        const filters = section.querySelectorAll('.filter-item a');
        filters.forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const item = link.closest('.filter-item') || link;

                section.querySelectorAll('.filter-item.open').forEach((openEl) => {
                    if (openEl !== item) openEl.classList.remove('open');
                });

                item.classList.toggle('open');
            });
        });
    });
}

export { dm_posts };